import { isFeatureEnabled } from './featureFlags';
import { thalesLogout } from '../../auth/authUtils';

const isHtmlResponse = (data: unknown): boolean =>
  typeof data === 'string' && /<!doctype html>/i.test(data);

const handleExpiredAuthAPIResponse = (
  data: unknown,
  sessionStore: { setIsAuthenticated: (value: boolean | null) => void },
  navigate?: (path: string) => void,
  status?: number
): boolean => {
  if (isHtmlResponse(data) || status === 401 || status === 403) {
    if (isFeatureEnabled('thalesImplementation')) {
      thalesLogout(sessionStore);
    } else {
      sessionStore.setIsAuthenticated(false);
      if (navigate) navigate('/');
    }
    return false;
  }
  return true;
};

export default handleExpiredAuthAPIResponse;
